import React, { useState, useRef, ReactNode } from "react";
import { FaChevronDown, FaChevronUp, FaEllipsisV } from "react-icons/fa";
import "./CardHeader.css";
import Dropdown from "../Dropdown";

/* export interface MenuItem {
  label: string;
  onClick: () => void;
  variant?: "default" | "danger";
  show?: boolean;
} */

export interface MenuItem {
  label: string;
  onClick?: () => void;
  variant?: "default" | "danger";
  show?: boolean;
  children?: MenuItem[];
}

interface CardHeaderProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  statusBadge?: ReactNode;
  rightContent?: ReactNode;
  menuItems?: MenuItem[];
  className?: string;
  isLoading?: boolean;
}

const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  isExpanded,
  onToggle,
  statusBadge,
  rightContent,
  menuItems = [],
  className = "",
  isLoading = false,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuBtnRef = useRef<HTMLButtonElement>(null);

  const visibleItems = menuItems.filter((item) => item.show !== false);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null); // NEW: tracks clicked item for submenu

  return (
    <div
      className={`base-card-header ${isExpanded ? "expanded" : ""} ${className}`}
      onClick={onToggle}
    >
      <div className="base-card-header-gradient" />

      <button
        className="base-card-header-arrow"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        aria-label={isExpanded ? "Collapse" : "Expand"}
      >
        {isExpanded ? (
          <FaChevronUp size={18} color="#7D7C85" />
        ) : (
          <FaChevronDown size={18} color="#7D7C85" />
        )}
      </button>

      <span className="base-card-header-title">
        {isLoading ? "Loading..." : title}
      </span>

      {statusBadge}
      {rightContent}

      {visibleItems.length > 0 && (
        <>
          <button
            className="base-card-header-menu-btn"
            ref={menuBtnRef}
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen(!menuOpen);
            }}
            aria-label="Open menu"
          >
            <FaEllipsisV size={22} color="#7D7C85" />
          </button>

          <Dropdown
            open={menuOpen}
            anchorRef={menuBtnRef}
            className="base-card-dropdown"
            onClose={() => setMenuOpen(false)}
          >
{/*             {visibleItems.map((item, i) => (
              <button
                key={i}
                className={`base-card-dropdown-item ${item.variant === "danger" ? "danger" : ""}`}
                onClick={(e) => {
                  e.stopPropagation();
                  item.onClick();
                  setMenuOpen(false);
                }}
              >
                {item.label}
              </button>
            ))} */ }
            {visibleItems.map((item, i) => (
  <div
    key={i}
    className="base-card-dropdown-item-wrapper"
  >
    <button
      className={`base-card-dropdown-item ${item.variant === "danger" ? "danger" : ""} ${item.children ? "has-submenu" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        if (item.children) {
          setExpandedIndex(expandedIndex === i ? null : i); // toggle submenu on click
        } else {
          item.onClick?.();
          setMenuOpen(false);
        }
      }}
    >
      {item.label}
      {item.children && <span className="submenu-arrow">›</span>}
    </button>
    {item.children && expandedIndex === i && (
      <div className="base-card-submenu">
        {item.children.map((child, j) => (
          <button
            key={j}
            className={`base-card-dropdown-item ${child.variant === "danger" ? "danger" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              child.onClick?.();
              setMenuOpen(false);
              setExpandedIndex(null);
            }}
          >
            {child.label}
          </button>
        ))}
      </div>
    )}
  </div>
))}
          </Dropdown>
        </>
      )}
    </div>
  );
};

export default CardHeader;
